module.exports = ".widget-11-2 .widget-11-2-table{height:273px}\n"